import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orders-report',
  templateUrl: './orders-report.component.html',
  styleUrls: ['./orders-report.component.scss']
})
export class OrdersReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
